<template>
    <a-modal title="催办单信息"
             class="wf-modal"
             :destroyOnClose="true"
             :width="600"
             :footer="null"
             :visible="visible"
             @cancel="onCancel"
             :confirmLoading="modalLoading">
        <div class="result">
            <a-alert v-if="isShowWarnMsg" style="text-align: left;" :message="warnMsg" banner />
            <br />
            <a-form :form="urgenceForm">
                <table class="fx-form-view">
                    <tr>
                        <th>经&nbsp;办&nbsp;人<span style="color: #ff0000;">*</span></th>
                        <td colspan="3">
                            <a-select placeholder="请选择经办人" style="width: 60%" @change="onHandlerChange" v-model="initData.handlerId" :value="initData.handlerId" :disabled="initData.isAllHandler === '1'">
                                <a-select-option v-for="item in passHeadlerData" :key="item.value">
                                    {{ item.text }}
                                </a-select-option>
                            </a-select>&nbsp;&nbsp;
                            <a-checkbox style="width: 30%" @change="onAllHandlerChange">所有经办人</a-checkbox>
                        </td>
                    </tr>
                    <tr v-show="initData.isAllHandler !== '1'">
                        <th>其他人员</th>
                        <td colspan="3">
                            <user-selector multiple  @change="onOtherUsersChange"/>
                        </td>
                    </tr>
                    <tr>
                        <th>办理期限</th>
                        <td colspan="3">
                            <a-date-picker placeholder="请输入办理期限" format="YYYY-MM-DD" @change="onLimitDateChange"/>
                        </td>
                    </tr>
                    <tr>
                        <th>说明事项<span style="color: #ff0000;">*</span></th>
                        <td colspan="3">
                            <a-textarea placeholder="请输入说明事项" v-model="initData.explain" autosize/>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <a-checkbox @change="onMsgChange">短信提醒</a-checkbox>
                        </th>
                        <td colspan="3">
                            <a-textarea placeholder="请输入短信内容" v-model="initData.msgContent" autosize/>
<!--                            <a-alert style="text-align: left;" message='注：短信内容中的空格将统一用"_"符号替换，回车换行将统一用"___"符号替换。' banner />-->
                        </td>
                    </tr>
<!--                    <tr>-->
<!--                        <th>签名</th>-->
<!--                        <td colspan="3">-->
<!--                            <a-textarea placeholder="请输入签名" v-model="initData.signature"/>-->
<!--                        </td>-->
<!--                    </tr>-->
                </table>
            </a-form>
        </div>
        <div class="action">
            <a-button type="primary" @click="onSubmit">确定</a-button>&nbsp;&nbsp;
            <a-button @click="onCancel">关闭窗口</a-button>
        </div>
    </a-modal>
</template>

<script>
import qs from 'qs'
import moment from 'moment'
import UserSelector from '@/components/selector/UserSelector'

const uuidv4 = require('uuid/v4')

export default {
  name: 'WorkflowUrgencyAdd',
  components: {
    UserSelector
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.user = this.$ls.get('user')
  },
  mounted () {
    this.$nextTick(function () {
    })
  },
  data () {
    return {
      user: {},
      urgenceForm: this.$form.createForm(this),
      modalLoading: false,
      xwfState: {},
      procInsId: '',
      caseId: '',
      uuid: uuidv4(),
      initData: {},
      passHeadlerData: [],
      isShowWarnMsg: false,
      warnMsg: '没有可催办对象，您的催办对象可能包含局领导，无法执行催办操作。'
    }
  },
  watch: {
  },
  methods: {
    // 已知 xwfState 参数，可直接传参
    preData ($xwfState) {
      this.initformData()

      this.xwfState = $xwfState
      this.caseId = this.xwfState.caseId
      this.procInsId = this.xwfState.procInsId

      this.initData.msgContent = '您有一个待办“' + this.xwfState.procIns.title + '”，请您及时登录办公自动化系统（OA）处理。'

      this.getNextPassUsers()
    },
    // 未知 xwfState 参数，需传业务caseId 获取xwfState
    loadXwfState ($caseId, $limitDate) {
      let that = this
      this.$http.get('/api/1/workflow/xwf_state.json?id=' + $caseId).then(function (response) {
        let result = response.result
        that.preData(result)

        // 此判断只针对收文判断，其他模块请忽略
        if ($limitDate && $limitDate !== '') {
          that.initData.msgContent = '【' + this.xwfState.procIns.title + '】将于【' + $limitDate + '】到期，如尚未办理，请尽快办理，并及时向办公室报告销号；如已办理完毕，请忽略。'
        }
      })
    },
    initformData () {
      this.initData = {
        handlerId: '',
        otherUsers: '',
        explain: '',
        isSendMsg: '0',
        msgContent: '',
        signature: this.user.name,
        isAllHandler: '0',
        limitDate: ''
      }
    },
    getNextPassUsers () {
      let that = this
      /**
       * 获取下一步经办用户信息
       */
      that.passHeadlerData = []
      that.isShowWarnMsg = false
      that.$http.get('/api/1/workflow/get_case_urgency_handlers.json?caseId=' + that.caseId).then(function (resp) {
        if (resp.code !== 200 || !resp.result || resp.result.length === 0) {
          that.isShowWarnMsg = true
          return
        }

        let handlerResult = resp.result

        for (let i = 0; i < handlerResult.length; i++) {
          let pitem = handlerResult[i]

          let nitem = {
            actId: pitem.act_id,
            actInsId: pitem.act_ins_id,
            actName: pitem.act_name,
            handlerId: pitem.handler_id,
            handlerName: pitem.handler_name,
            value: pitem.handler_id,
            text: pitem.handler_name + '[' + pitem.act_name + ']'
          }

          that.passHeadlerData.push(nitem)
        }

        if (that.passHeadlerData && that.passHeadlerData.length === 1) {
          that.initData.handlerId = that.passHeadlerData[0].value
        }
      })
    },
    onHandlerChange ($value) {
      this.initData.handlerId = $value
    },
    onOtherUsersChange (selectedIds) {
      this.initData.otherUsers = selectedIds
    },
    onAllHandlerChange (e) {
      this.initData.isAllHandler = e.target.checked ? '1' : '0'
    },
    onLimitDateChange (date, dateString) {
      this.initData.limitDate = dateString
    },
    onMsgChange (e) {
      this.initData.isSendMsg = e.target.checked ? '1' : '0'
    },
    onCancel () {
      this.$emit('cancel')
    },
    onSubmit () {
      const that = this
      let data = that.initData
      console.log('data:', data)

      let urgencyList = []
      if (data.isAllHandler === '1') {
        urgencyList = JSON.parse(JSON.stringify(this.passHeadlerData))
      } else {
        if (data.handlerId !== '') {
          let target = this.passHeadlerData.find(item => item.value === data.handlerId)
          if (target) {
            urgencyList.push(target)
          }
        }
      }

      if (!urgencyList || urgencyList.length === 0) {
        that.$message.error('没有选定经办人或没有可催办对象，无法执行催办操作。')
        return
      }

      // if (data.limitDate === '') {
      //   that.$message.error('请输入办理期限')
      //   return
      // }

      if (data.limitDate !== '' && new Date(data.limitDate) < new Date()) {
        this.$message.error('办理时限必须在当前时间之后')
        return
      }

      if (data.explain === '') {
        that.$message.error('请输入说明事项')
        return
      }

      data.id = that.uuid
      data.caseId = that.caseId
      data.title = that.xwfState.procIns.title
      data.procInsId = that.procInsId
      data.urgencyList = urgencyList

      that.modalLoading = true
      this.$http.post('/api/1/workflow/urgency/add_urgency.json', qs.stringify(data, { allowDots: true })).then(function (response) {
        that.modalLoading = false
        if (response.code !== 200) {
          return
        }
        that.$message.success('操作成功')
        that.$emit('success')
      }).catch(function () {
        that.$message.error('操作失败')
      })
    }
  }
}
</script>

<style>
    .wf-modal .ant-modal-body {
        padding: 12px !important;
    }

    .wf-card .ant-card-body {
        padding: 0 !important;
    }

    .wf-card-title {
        border-width: 1px 1px 0 1px;
        border-style: solid;
        border-color: #b2d5f2;
        background-color: #e2f2ff;
        padding: 8px;
    }

    .wf-card-body {
        height: 280px;
        overflow-y: auto;
        border: 1px solid #b2d5f2;
        padding: 5px;
    }

    .wf-cards {
        display: flex;
        flex-wrap: wrap;
    }

    .wf-modal .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        color: rgba(0,0,0,.65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }

    .wf-modal .ant-modal-title {
        color: #fff;
    }

    .wf-modal .ant-modal-close-x {
        color: #fff;
    }
</style>

<style lang="less" scoped>
    .wf-cards {
        /deep/ .ant-checkbox-wrapper {
            height: auto;
            padding: 2px 0;
        }

        /deep/ .ant-radio-wrapper {
            height: auto;
            padding: 2px 0;
        }

        /deep/ .ant-radio-wrapper span {
            white-space: initial;
        }
    }

    .result {
        text-align: center;
        width: 100%;
        margin: 0 auto;
        padding: 24px 0 8px;

        .icon {
            font-size: 72px;
            line-height: 72px;
            margin-bottom: 24px;
        }
        .success {
            color: #52c41a;
        }
        .error {
            color: red;
        }
        .title {
            font-size: 24px;
            color: rgba(0, 0, 0, .85);
            font-weight: 500;
            line-height: 32px;
            margin-bottom: 16px;
        }
        .description {
            font-size: 14px;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.45);
            margin-bottom: 24px;
        }
        .content {
            background: #fafafa;
            padding: 24px 40px;
            border-radius: 2px;
            text-align: left;
        }

        .fx-form-view td {
            text-align: left;
        }

    }

    .action {
        margin-top: 32px;
        text-align: right;
    }

    /deep/ .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        color: rgba(0,0,0,.65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }
</style>
